module.exports = __webpack_public_path__ + "static/media/silkycloud-gold-1.091886b3.png";